import { InputBase, styled } from '@mui/material'

const StyledSearchInput = styled(InputBase)(({ theme }) => ({
    width: '100% !important',
    'label + &': {
        marginTop: theme.spacing(3),
    },
    input: {
        borderRadius: '0.4rem',
        position: 'relative',
        backgroundColor: `${theme?.palette?.common?.white} !important`,
        border: 'solid 0.1rem #ebebed',

        fontSize: '1.5rem',
        padding: '1rem 1.2rem',
        '&:focus': {
            boxShadow: ` 0 0.2rem 0.4rem 0 ${theme?.palette?.primary?.light}`,
            borderColor: theme?.palette?.primary?.main,
            backgroundColor: theme?.palette?.common?.white,
        },
    },

    focused: {
        backgroundColor: theme?.palette?.common?.white,
    },
}))

export default StyledSearchInput
